(function () {
  // Mappa traduzioni (aggiungi lingue qui quando ti servono)
  const TRANSLATIONS = {
    it: "ORDINA CON LENTI GRADUATE",
    en: "ORDER PRESCRIPTION LENSES",
  };

  // Rileva lingua Shopify in modo affidabile
  function getLocale() {
    // Shopify.locale spesso è tipo "en" o "it"
    if (window.Shopify && typeof window.Shopify.locale === "string") return window.Shopify.locale.toLowerCase();

    // Fallback: <html lang="en-US">
    const htmlLang = document.documentElement.lang || "";
    if (htmlLang) return htmlLang.toLowerCase().split("-")[0];

    // Fallback URL: /en-us, /it, ecc.
    const m = window.location.pathname.match(/^\/([a-z]{2})(-|\/)/i);
    if (m) return m[1].toLowerCase();

    return "it";
  }

  function applyTranslation() {
    const locale = getLocale();
    const text = TRANSLATIONS[locale] || TRANSLATIONS.it;

    // Evita un selettore troppo fragile con l'id del block (che può cambiare)
    const buttons = document.querySelectorAll(".lool-popup-trigger.lool-style-Z6JYWM");

    buttons.forEach((btn) => {
      // Sostituisci solo se necessario
      if (btn.textContent.trim() !== text) {
        btn.textContent = text;
      }
    });
  }

  // Prima applicazione
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyTranslation);
  } else {
    applyTranslation();
  }

  // Se l’app reinietta o cambia DOM, riapplica
  const observer = new MutationObserver(() => applyTranslation());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Se hai un language switcher che cambia senza reload (raro su Shopify), puoi anche ascoltare click
  window.addEventListener("popstate", applyTranslation);
})();
